export function OutlineUserIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0016 10.9968C14.2098 10.9968 16 9.20667 16 6.99841C16 4.79015 14.2098 3 12.0016 3C9.79332 3 8.00317 4.79015 8.00317 6.99841C8.00317 9.20667 9.79332 10.9968 12.0016 10.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9968 14.002H18.0016C19.1056 14.002 19.9984 14.8948 19.9984 15.9988V21.0004H4V15.9988C4 14.8948 4.8928 14.002 5.9968 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
